import { Route } from "react-router-dom";
import { RoutesWithnotfound } from "../../utils";
import { PrivateRoutes } from "../../routes";
import { Tarjetas, InfoPersonal, VerificacionEmail, Finalizar, Gracias, AppMobile } from "./index"
import React from "react";
import { LoadingModalProps } from "../../models";


interface PrivateProps {
    onLoadingModal: (value: LoadingModalProps) => void;
}

const Private: React.FC<PrivateProps> = ({ onLoadingModal }) => {
    return (
        <RoutesWithnotfound>
            <Route path={PrivateRoutes.TARJETAS} element={<Tarjetas onLoadingModalPrivate={onLoadingModal} />} />
            <Route path={PrivateRoutes.DATOSPEROSANLES} element={<InfoPersonal />} />
            <Route path={PrivateRoutes.VERIFICACIONEMAIL} element={<VerificacionEmail idtramite="0" email={""} onOpenSnack={() => { }} onSetPopUp={() => { }} onUpModal={() => { }} />} />
            <Route path={PrivateRoutes.FINALIZAR} element={<Finalizar />} />
            <Route path={PrivateRoutes.GRACIAS} element={<Gracias />} />
            <Route path={PrivateRoutes.APPMOBILE} element={<AppMobile />} />
        </RoutesWithnotfound>
    );
}

export default Private;